import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

function Accordion(props) {
  const {
    children,
    heading = '',
    subHeading = '',
    expandIcon = '+',
    collapseIcon = '-',
    collapseDisable,
    disabled=false,
  } = props;

  const [isOpen, setIsOpen] = useState(collapseDisable?true:false);

  useEffect(()=>{
    setIsOpen(collapseDisable?true:false)
  },[collapseDisable])
  
  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="border rounded-lg shadow-md p-4 mb-4 bg-gray-25">
      {/* Accordion Header */}
      <div
        className="flex justify-between items-center cursor-pointer"
        onClick={disabled? ()=>{} : (collapseDisable? ()=>{} :toggleAccordion)}
      >
        {heading && <span className="font-semibold text-base">{heading}</span>}
        <span className="text-xl">
          {isOpen ? collapseIcon() : expandIcon()}
        </span>
      </div>

      {/* Accordion Content */}
      <div
        className={`overflow-hidden transition-[max-height] duration-500 ease-in-out ${
          isOpen ? 'max-h-96' : 'max-h-0'
        }`}
      >
        <div className=''>
        {subHeading && <><span className='text-sm'>{subHeading}</span></>}
        <div className="mt-4">{children}</div>
        </div>
      </div>
    </div>
  );
}

Accordion.propTypes = {
  children: PropTypes.node.isRequired, 
  heading: PropTypes.string, 
  expandIcon: PropTypes.node, 
  collapseIcon: PropTypes.node, 
};

export default Accordion;
